import React from 'react'
import './style.css'

const AzureLoginButton = ({ text, onClick }) => {
  const handleButtonClick = () => {
    if (onClick) {
      onClick()
    }
  }

  return (
    <button type="button" onClick={handleButtonClick} className="azure-login-button">
      {text}
    </button>
  )
}

export default AzureLoginButton
